// extracted by mini-css-extract-plugin
export default {"tags":"RowTags_tags__6eczp","clickable":"RowTags_clickable__pvzrQ","color":"RowTags_color__LRwdl"};